/**
 * Wallet utilities: kobo <-> naira conversion and money formatting.
 *
 * All money in the app travels as integer kobo. The UI only converts to
 * naira at the very edge (display + form input parsing). Floats are
 * banned everywhere else.
 */

export function koboToNaira(kobo) {
  if (kobo == null || Number.isNaN(kobo)) return 0;
  return Math.trunc(kobo) / 100;
}

export function nairaToKobo(naira) {
  // We accept either a number or a numeric string and round to the nearest kobo.
  const n = typeof naira === 'string' ? Number(naira) : naira;
  if (!Number.isFinite(n)) return NaN;
  return Math.round(n * 100);
}

const nairaFormatter = new Intl.NumberFormat('en-NG', {
  style: 'currency',
  currency: 'NGN',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatKobo(kobo) {
  return nairaFormatter.format(koboToNaira(kobo));
}

const dateFormatter = new Intl.DateTimeFormat('en-NG', {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

export function formatDate(value) {
  if (!value) return '';
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return dateFormatter.format(d);
}

export function txnKindLabel(kind) {
  switch (kind) {
    case 'deposit': return 'Deposit';
    case 'withdrawal': return 'Withdrawal';
    case 'withdrawal_reversal': return 'Withdrawal reversed';
    case 'contest_stake': return 'Contest entry';
    case 'contest_settle': return 'Contest payout';
    case 'contest_refund': return 'Contest refund';
    default: return kind;
  }
}

export function txnStatusClass(status) {
  switch (status) {
    case 'succeeded': return 'ok';
    case 'failed': return 'bad';
    case 'cancelled': return 'bad';
    default: return 'warn';
  }
}

/**
 * Returns a short user-facing label for a non-succeeded txn, or null when
 * succeeded (in which case we don't render a badge — the row is the badge).
 * Pending withdrawals get a friendlier "Awaiting approval" label because
 * that's the actual user-visible meaning of the manual-review state.
 */
export function txnStatusLabel(kind, status) {
  if (status === 'succeeded') return null;
  if (status === 'failed') return 'Failed';
  if (status === 'cancelled') return 'Cancelled';
  if (status === 'pending') {
    return kind === 'withdrawal' ? 'Awaiting approval' : 'Pending';
  }
  return status;
}
